export default "__VITE_ASSET__DLj2YLhp__"